import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

import {ContentPage} from './components/content-page/content-page';
import {ContentPurchasePage} from './components/content-purchase-page/content-purchase-page';
import { ContentFlowPage } from './components/content-flow-page/content-flow-page';
import {ContentRepository} from './repositories/content.repository';
import {ContentService} from './services/content.service';
import { FormsModule } from '@angular/forms';
import { LeadaComponentsModule } from 'shared/components';
import { CertificatesPage } from './components/certificates-page/certificates-page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      { path: '', component: ContentPage },
      { path: 'purchase', component: ContentPurchasePage },
      { path: 'flow', component: ContentFlowPage },
      { path: 'certificates', component: CertificatesPage },
    ]),
    TranslateModule,
    LeadaComponentsModule,
  ],
  providers: [
    ContentRepository,
    ContentService,
  ],
  declarations: [
    ContentPage,
    ContentPurchasePage,
    ContentFlowPage,
    CertificatesPage,
  ],
  // entryComponents: [
  //   ContentPage,
  //   ContentFlowPage,
  //   CertificatesPage,
  // ],
})
export class ContentModule { }
